import { render } from "./trainingParticipantsTable.vue?vue&type=template&id=134eeb3f&scoped=true&ts=true"
import script from "./trainingParticipantsTable.vue?vue&type=script&lang=ts"
export * from "./trainingParticipantsTable.vue?vue&type=script&lang=ts"

import "./trainingParticipantsTable.vue?vue&type=style&index=0&id=134eeb3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134eeb3f"]])

export default __exports__